import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CompanyService } from 'src/app/services/companies-services/company.service';
import { CompanyModel } from 'src/app/models/company.model';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-companies-companies-list-card',
    templateUrl: './companies-companies-list-card.component.html',
    styleUrls: ['./companies-companies-list-card.component.scss'],
    standalone: false
})
export class CompaniesCompaniesListCardComponent implements OnInit {

  companies: CompanyModel[] = [];
  sortedCompanies: CompanyModel[] = [];
  sortField: 'companyName' | 'companyCif' | 'country' | 'companyServices' = 'companyName';
  sortDirection: 'asc' | 'desc' = 'asc';
  pendingDeleteCompany: CompanyModel = null;

  constructor(
    private companyService: CompanyService,
    private destroyRef: DestroyRef
  ) { }

  ngOnInit() {
    this.listenRefreshCompanies();
    this.getCompanies();
  }

  public getCompanies() {
    this.companyService.getCompanies().pipe(
      takeUntilDestroyed(this.destroyRef),
      tap((res: CompanyModel[]) => {
        this.companies = res || [];
        this.applySort();
      })
    ).subscribe();
  }

  public setSort(field: 'companyName' | 'companyCif' | 'country' | 'companyServices') {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }
    this.applySort();
  }

  public sortIndicator(field: 'companyName' | 'companyCif' | 'country' | 'companyServices') {
    if (this.sortField !== field) {
      return '↕';
    }
    return this.sortDirection === 'asc' ? '▲' : '▼';
  }

  public deleteCompany(company) {
    this.pendingDeleteCompany = company;
  }

  public cancelDeleteCompany() {
    this.pendingDeleteCompany = null;
  }

  public confirmDeleteCompany() {
    if (!this.pendingDeleteCompany) {
      return;
    }
    this.companyService.deleteCompany(this.pendingDeleteCompany.internalId).pipe(
      takeUntilDestroyed(this.destroyRef),
      tap(res => this.companyService.refreshCompanies())
    ).subscribe();
    this.pendingDeleteCompany = null;
  }

  private listenRefreshCompanies() {
    this.companyService.listenRefreshCompanies().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(
      (res) => {
        this.getCompanies();
      }
    );
  }

  private applySort() {
    const factor = this.sortDirection === 'asc' ? 1 : -1;
    this.sortedCompanies = [...this.companies].sort((a: CompanyModel, b: CompanyModel) => {
      const left = ((a as any)[this.sortField] ?? '').toString().toLowerCase();
      const right = ((b as any)[this.sortField] ?? '').toString().toLowerCase();
      return left.localeCompare(right) * factor;
    });
  }
}
